module.exports = __webpack_public_path__ + "img/icon-folder-light-blue.4dc411b2.svg";